<template>
    <div>
    <v-autocomplete
        hide-selected

        :cache-items="false"
        :no-filter="true"
        :filter="filterItem"

        :no-data-text="nodatatext"

        v-model="val"
        v-bind="{dark,color,outlined,dense,filled,solo,multiple,chips,persistentHint,clearable,label,hint,
        itemText,itemValue,singleLine,placeholder,prependIcon,deletableChips,filter}"
        :loading="isLoading"
        :disabled="isDisabled"

        :search-input.sync="search"
        :items="allItems"

        @focus="onFocus"
        @change="onChange"
        :error-messages="allErrors"
        :return-object="true"

        :rules="rules"
        >

        <template v-slot:selection="data">
            <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                :close="multiple && !isDisabled"
                @click="data.select"
                @click:close="remove(data.item)"
                >
                <slot v-bind:item="data.item">{{data.item[itemText]}}</slot>
            </v-chip>
        </template>
        <template v-slot:item="{item}">
            <slot v-bind:item="item">{{item[itemText]}}</slot>
        </template>
    </v-autocomplete>
    </div>
</template>
<script>
import _ from "lodash";

export default {
    name: "ItemSelector",
    props: {
        value: {},
        loading: {},

        //ResourceQuery target
        action: { type: String, default: '' },
        //Query parameter, default 'q', ex: "your-url?q=<search-string>"
        queryParameter: { type: String, default: 'q' },
        //Query parameter for returning object by item value, defaults to item-value, ex: your-action?id=1
        fetchValueParameter: { type: String },

        //combobox values
        multiple: {},
        chips: { default: true, },
        label: {},
        hint: {},
        placeholder: {},

        outlined: {}, dense: {}, filled: {}, solo: {}, dark: {}, color: {},
        persistentHint: {},
        clearable: {},
        disabled: {},
        singleLine: {},
        prependIcon: {},
        deletableChips: {},
        //
        filter: {},
        itemText: { type: String, },
        itemValue: { type: String, default: 'id' },
        returnObject: { type: Boolean, default: true },

        rules: { default() { return [] } },
        //
        debounce: { type: Number, default: 300 },
        preload: { type: Boolean, default: false, },
        ///
        errorMessages: { type: Array },

        noDataText: { type: String, default: 'No data available' },
        loadingText: { type: String, default: 'Loading...' },
    },
    data() {
        return {
            search: '',
            //item value
            val: this.value,

            items: [],

            error: null,
            processing: false,
            prefetching: false,

            debounceSearch: _.debounce(function (s) {
                this.fetchData(s);
            }, this.debounce),
        };
    },
    mounted() {
        this.loadValue(this.value);
        if (this.preload)
            this.fetchData();
    },
    computed: {
        nodatatext() { return this.isLoading ? this.loadingText : this.noDataText },
        isLoading() { return this.loading || this.processing; },
        isDisabled() { return this.disabled || this.prefetching },
        allErrors() {
            let e = [];
            if (this.error)
                e.push(this.error);
            if (this.errors)
                e.concat(this.errors);
            if (this.errorMessages)
                e.concat(this.errorMessages);
            return e;
        },
        allItems() {
            let v = (this.val && (Array.isArray(this.val) ? this.val : [this.val])) || [];
            return v.concat(this.items)
        },
        filterItem() {
            return this.filter || ((item, queryText, itemText) => {
                //filter only server items
                return this.items.indexOf(item) !== -1;
            });
        },
    },
    methods: {
        /**
         * Load external value into internal value, will fetch values if passed by keys and not present
         **/
        loadValue(value) {
            //Check if different
            if (!this.val && !value)
                return;//both null

            let differs = false;
            let hasToPrefetch = false;
            let prefetchIds = [];

            /// on null value set null
            if (value === null) {
                this.val = this.multiple ? [] : null;
                return;
            }

            //Index by value current selection
            let indexVal = {};
            if (this.multiple) {
                for (let e of this.val) {
                    indexVal[e[this.itemValue]] = e;
                }
            } else {
                if (this.val) {
                    indexVal[this.val[this.itemValue]] = this.val;
                }
            }

            let newVal = {};
            // check if is similar
            for (let v of (Array.isArray(value) ? value : [value])) {
                if (v[this.itemValue]) {
                    //object
                    let id = v[this.itemValue];
                    prefetchIds.push(id);
                    if (indexVal[id] === undefined) {
                        //Not fetched
                        differs = true;
                        indexVal[id] = v;//Set to new value object
                    } else {
                        newVal[id] = indexVal[id];
                    }
                } else {
                    //value
                    let id = v;
                    prefetchIds.push(id);
                    if (indexVal[id] === undefined) {
                        //Must be fetched
                        differs = true;
                        hasToPrefetch = true;//<< need to be prefetch
                    } else {
                        newVal[id] = indexVal[id];
                    }
                }
            }

            if (differs) {
                this.search = '';
                if (hasToPrefetch) {
                    this.prefetchObjects(prefetchIds);
                } else {
                    this.val = value;
                }
            } else {
                //Check if has removed items
                let oldVal = Object.values(indexVal);
                let currentVal = Object.values(newVal);
                if (oldVal.length !== currentVal.length) {
                    this.val = this.multiple ? currentVal : (currentVal[0] || null);
                }
            }
        },
        fetchData() {
            let params = {
                [this.queryParameter]: this.search,
            };
            this.processing = true;
            this.items = [];
            axios.get(this.action, { params, })
                .then(r => {
                    if (!r.data) {
                        throw 'Invalid response';
                    }
                    this.items = r.data.data || r.data;
                    /* //Set first if only one item
                     if(this.items.length===1){
                         this.val=this.items[0];
                     }
                     //*/
                }).catch(e => {
                    console.log('error', { e });
                    this.error = (e.response && e.response.data && e.response.data.message) || "" + e;
                    this.errors = (e.response && e.response.data && e.response.data.errors) || null;
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        prefetchObjects(v) {
            let ids = Array.isArray(v) ? v : [v];
            let len = ids.length;

            let params = {
                [this.fetchValueParameter || this.itemValue || 'id']: v,
            };
            this.processing = true;
            this.prefetching = true;

            axios.get(this.action, { params, })
                .then(r => {
                    if (!r.data) {
                        throw 'Invalid response';
                    }
                    let data = r.data.data || r.data;
                    this.val = this.multiple ? data : data[0];
                    if (this.multiple && this.val.length !== len) {
                        console.warn('Prefetched values differs from values!');
                    }
                }).catch(e => {
                    console.log('error', { e });
                    this.error = (e.response && e.response.data && e.response.data.message) || "" + e;
                    this.errors = (e.response && e.response.data && e.response.data.errors) || null;
                })
                .finally(() => {
                    this.processing = false;
                    this.prefetching = false;
                });
        },
        onFocus() {
            if (this.items.length === 0 && !this.search) {
                this.fetchData();//<< Preload empty
            }
        },
        onChange(v) {
            this.search = '';
            this.$emit('change', v)
        },
        find(s) {
            console.log(' FIND:', s)
            this.processing = true;
            this.debounceSearch(s);
        },
        remove(item) {
            const index = this.value.indexOf(item)
            if (index >= 0)
                this.value.splice(index, 1)
        },
    },
    watch: {
        search(s) {
            s && this.find(s)
        },
        val(v) {
            if (!this.returnObject) {
                //If returnobject is false return only keys
                v = v && ((Array.isArray(v)) ? v.map(e => e[this.itemValue]) : v[this.itemValue]);
                this.$emit('input', v);
            } else
                this.$emit('input', v)
        },
        value(v) {
            this.loadValue(v)
        }
    }
}
</script>
